// Build-time prerender state (#2567). scripts/prerender.mjs renders every
// public route through the real <App /> in Node and sets this global first;
// the SSR bundle reads it so a page renders the way a signed-out visitor sees
// it once the app has settled: auth resolved to signed out, the public GA
// flags known, and each page's usePageMeta recorded for the HTML head.
//
// import.meta.env.SSR is false in the client bundle, so every branch that
// reads this is dead code there and the browser never looks for the global.
export const PRERENDER_KEY = '__STRATIA_PRERENDER__';

export function prerenderState() {
    if (!import.meta.env.SSR) return null;
    return globalThis[PRERENDER_KEY] || null;
}

// Hydration (#2605). A prerendered public page ships the real React markup in
// #root, marked data-prerendered="<path>", and the public flags the build
// rendered with as window.__STRATIA_PUBLIC_FLAGS__. The browser hydrates that
// markup in place instead of hiding it and rendering again, so the page paints
// before the bundle loads. The client's first render must equal the build's:
// auth starts loading (both sides) and the public flags start from the seed.
export const FLAGS_SEED_KEY = '__STRATIA_PUBLIC_FLAGS__';

const normPath = (p) => (p.length > 1 ? p.replace(/\/+$/, '') : p);

/** True when #root holds the build's markup for THIS path. */
export function isHydratingPrerender() {
    if (import.meta.env.SSR || typeof document === 'undefined') return false;
    const root = document.getElementById('root');
    const at = root && root.getAttribute('data-prerendered');
    return !!at && normPath(at) === normPath(window.location.pathname);
}

/** The public flags the prerendered markup was built with, or null. */
export function hydrationFlagsSeed() {
    if (!isHydratingPrerender()) return null;
    const seed = window[FLAGS_SEED_KEY];
    return seed && typeof seed === 'object' ? seed : null;
}

// The college pages' Watch section (#4608): the build reads the list once and
// renders each college page with its own videos; the page's HTML carries the
// videos it rendered as window.__STRATIA_COLLEGE_VIDEOS__ = {path, videos}, so
// the browser's first render equals the build's. Fresh posts arrive after
// mount from the live read.
export const VIDEOS_SEED_KEY = '__STRATIA_COLLEGE_VIDEOS__';

/** /videos' most-watched Shorts the markup was built with (#5433), or null. */
export function hydrationTopSeed() {
    if (!isHydratingPrerender()) return null;
    const seed = window[VIDEOS_SEED_KEY];
    const top = seed && typeof seed === 'object' && normPath(String(seed.path || '')) === normPath(window.location.pathname)
        ? seed.top : null;
    return top && typeof top === 'object' && Array.isArray(top.shorts) ? top : null;
}

/** The videos the prerendered markup was built with, or null. */
export function hydrationVideosSeed() {
    if (!isHydratingPrerender()) return null;
    const seed = window[VIDEOS_SEED_KEY];
    return seed && typeof seed === 'object' && Array.isArray(seed.videos)
        && normPath(String(seed.path || '')) === normPath(window.location.pathname) ? seed.videos : null;
}
